import baseApiClient from '@cnd_fe/ky-client'

// API용 클라이언트 생성
const client = baseApiClient.extend({
  prefixUrl: import.meta.env.VITE_RES_ADMIN_SERVICE_URL
})

// 초기 데이터 모델
export const initialInstSysSet = {
  instId:'',
  instNm:'',
  sysStngKey:'',
  sysStngVl:'',
  useYn:'',
  delYn:'',
  rmrkCn:'',
  todayChk:'',
}

// 사용여부 옵션
export const useYnItems = [
  { value: 'Y', label: '사용' },
  { value: 'N', label: '미사용' }
]

/**
 * 기관별시스템설정관리 목록 조회
 */
export const getInstSysSetList = async (payload = {}) => {
  try {
    const result = await client.post('inst-system/inst-system-set-list', { json: payload }).json()
    return result
  } catch (error) {
    throw error
  }
}

/**
 * 기관별시스템설정관리 상세 조회
 */
export const getInstSysSetById = (instId, sysStngKey) => {
  return client.post(`inst-system/inst-system-set-detail`, { json: { instId, sysStngKey } }).json()
}

/**
 * 기관별시스템설정관리 등록/수정 처리
 */
export const procInstSysSet = (payload) => {
  return client.post(`inst-system/inst-system-set-proc`, { json: payload }).json()
}

/**
 * 기관별시스템설정관리 소프트 삭제 (DEL_YN='Y')
 */
export const deleteInstSysSet = async (payload) => {
  const data = { ...payload, processGbn: 'D' }
  return client.post(`inst-system/inst-system-set-proc`, { json: data }).json()
}

/**
 * 기관별시스템설정관리 물리 삭제 (당일 등록 건만)
 */
export const forceDeleteInstSysSet = async (payload) => {
  const data = { ...payload, processGbn: 'FD' }
  return client.post(`inst-system/inst-system-set-proc`, { json: data }).json()
}

/**
 * 기관별시스템설정관리 복원
 */
export const restoreInstSysSet = async (payload) => {
  const data = { ...payload, processGbn: 'RS' }
  return client.post(`inst-system/inst-system-set-proc`, { json: data }).json()
}
